import { Box, CircularProgress, SxProps, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

/**
 * リダイレクトページ
 *
 * クエリパラメータ `url` を受け取り、そのURLにリダイレクトします。
 * アプリからブラウザで開く際の中継ページとして使用します。
 */
export default function RedirectPage() {
  const { t } = useTranslation('common')
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const url = searchParams.get('url')

    if (!url) {
      // URLが指定されていない場合はログインページにリダイレクト
      window.location.href = '/login'
      return
    }

    // React Routerが既にデコード済みなので、そのまま使用
    window.location.href = url
  }, [searchParams])

  return (
    <Box sx={redirectStyle}>
      <CircularProgress size={60} />
      <Typography variant="body1" color="text.secondary">
        {t('redirecting')}
      </Typography>
    </Box>
  )
}

const redirectStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  gap: 2,
}
